import { render } from "./CheckboxButton.vue?vue&type=template&id=6b7ec072"
import script from "./CheckboxButton.vue?vue&type=script&lang=js"
export * from "./CheckboxButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Button/CheckboxButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b7ec072"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b7ec072', __exports__)) {
    api.reload('6b7ec072', __exports__)
  }
  
  module.hot.accept("./CheckboxButton.vue?vue&type=template&id=6b7ec072", () => {
    api.rerender('6b7ec072', render)
  })

}


export default __exports__